// Auto-generated from translation.csv; do not edit manually
export const deDE = {
  "accountGuide": {
    "content": "Öffnen Sie ein beliebiges Touka-Spiel, gehen Sie auf dem Hauptbildschirm im Spiel zur E-Mail-Verknüpfung und verknüpfen Sie Ihre E-Mail-Adresse, um Sonderangebote zu nutzen!",
    "title": "Wie erstelle ich ein Konto?"
  },
  "bottomNav": {
    "home": "Startseite",
    "myOrders": "Meine Bestellungen"
  },
  "common": {
    "loading": "Laden...",
    "noData": "Keine Daten",
    "server": "Server"
  },
  "auth": {
    "tokenExpired": "Anmeldung abgelaufen"
  },
  "errors": {
    "900400": "Interner Parameterfehler",
    "900401": "Authentifizierung fehlgeschlagen",
    "900402": "Anmeldung abgelaufen",
    "1000000": "Systemfehler. Bitte versuchen Sie es später erneut",
    "1000001": "Systemparameterfehler. Bitte versuchen Sie es später erneut",
    "1000002": "Captcha-ID oder Code darf nicht leer sein",
    "1000003": "Ungültige E-Mail-Adresse",
    "1000004": "Ungültiger Captcha-Code",
    "1000005": "E-Mail-Code wurde bereits gesendet. Bitte warten Sie 1 Minute und versuchen Sie es erneut",
    "1000006": "Limit für E-Mail-Code erreicht. Bitte versuchen Sie es morgen erneut",
    "1000007": "E-Mail darf nicht leer sein",
    "1000008": "Code darf nicht leer sein",
    "1000009": "Ungültiger Code",
    "1000010": "Login-Token konnte nicht abgerufen werden",
    "1000011": "Produkt ist inaktiv. Bitte wählen Sie ein anderes Produkt",
    "1000012": "Das Kauflimit für dieses Produkt wurde überschritten. Bitte wählen Sie ein anderes Produkt",
    "1000013": "Das Produkt wurde offline genommen",
    "1000014": "Zahlungsmethode ist nicht aktiviert",
    "1000015": "Ihr Konto unterstützt den Kauf von Produkten nicht. Bitte kontaktieren Sie den Kundendienst",
    "1000016": "Bestellung konnte nicht erstellt werden. Bitte versuchen Sie es erneut",
    "1000017": "Diese Bestellung kann nicht storniert werden",
    "1000018": "Das Limit für die Menge pro Einzelkauf wurde erreicht",
    "1000019": "Der Verifizierungscode ist abgelaufen. Bitte fordern Sie einen neuen an"
  },
  "footer": {
    "language": "Chinesisch (vereinfacht)",
    "privacyPolicy": "Datenschutzrichtlinie",
    "refundPolicy": "Rückerstattungsrichtlinie",
    "termsOfService": "Nutzungsbedingungen",
    "userSupport": "Benutzersupport",
    "downloadNow": "Jetzt herunterladen!"
  },
  "header": {
    "characterName": "Charaktername",
    "gameServer": "Spielserver",
    "selectGameServer": "Spielregion auswählen",
    "greeting": "Hallo",
    "loginPrompt": "Bitte klicken Sie auf Anmelden",
    "switchServer": "Wechseln",
    "title": "Spiel-Aufladecenter",
    "logout": "Abmelden"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Oopsie Croco"
  },
  "history": {
    "backToGameZone": "Zurück zum Spiel-Shop",
    "allGames": "Alle Spiele",
    "empty": "Keine Bestellungen",
    "filter": {
      "all": "Alle",
      "closed": "Geschlossen",
      "completed": "Abgeschlossen",
      "inProgress": "In Bearbeitung",
      "pendingDelivery": "Ausstehender Versand "
    },
    "orderTime": "Bestellzeit:",
    "pendingAutoCancelPrefix": "Die Bestellung wird in",
    "pendingAutoCancelSuffix": "automatisch storniert",
    "cancelOrder": "Bestellung stornieren",
    "payOrder": "Bezahlen",
    "cancelOrderConfirmTitle": "Bestellung stornieren?",
    "cancelOrderConfirmPrimary": "Bestätigen",
    "cancelOrderDismiss": "Vorerst nicht",
    "cancelOrderSuccess": "Bestellung storniert",
    "previousPage": "Zurück",
    "nextPage": "Weiter",
    "status": {
      "cancelled": "Geschlossen",
      "completed": "Transaktion abgeschlossen ",
      "paid": "Bezahlt ",
      "pending": "Ausstehende Zahlung",
      "refunded": "Erstattet",
      "shipped": "Versandt"
    }
  },
  "home": {
    "selectGame": "Wählen Sie das Spiel, das Sie aufladen möchten",
    "selectGameMobileTitle": "Spiel zum Aufladen wählen",
    "mobileGameCardGo": "Los",
    "selectGameParts": {
      "prefix": "Wählen Sie das Spiel, das Sie ",
      "keyword": "aufladen",
      "suffix": " möchten"
    },
    "purchaseEntryParts": {
      "prefix": "Zum ",
      "keyword": "Kauf",
      "suffix": ""
    },
    "noRoleAccount": "Sie haben in diesem Spiel noch keinen Charakter. Bitte erstellen Sie zuerst einen Charakter im Spiel, bevor Sie kaufen.",
    "noRoleRefreshPrefix": "Konto bereits erstellt? Tippen Sie auf ",
    "noRoleRefreshAction": "Aktualisieren",
    "noRoleRefreshing": "Wird aktualisiert…",
    "noRoleRefreshNotFound": "Keine Charakterinformationen gefunden",
    "noRoleRefreshFailed": "Aktualisierung fehlgeschlagen. Bitte versuchen Sie es später erneut."
  },
  "login": {
    "agreeTerms": {
      "and": "und",
      "prefix": "Ich habe gelesen und stimme zu",
      "privacy": "Datenschutzrichtlinie",
      "terms": "Nutzungsbedingungen "
    },
    "cancel": "Abbrechen ",
    "bindGameGuide": "Hinweis zur Spielverknüpfung",
    "bindGameGuideContent": "Öffnen Sie ein beliebiges Touka-Spiel,\ngehen Sie zu den Spieleinstellungen,\nverknüpfen Sie Ihre E-Mail,\nund profitieren Sie von Sonderangeboten im Shop!",
    "captchaPlaceholder": "Bestätigungscode ",
    "invalidCaptcha": "Bitte geben Sie einen 4-stelligen Bestätigungscode ein",
    "email": "E-Mail ",
    "emailNotBound": "Konto nicht gefunden. Bitte geben Sie die im Spiel verknüpfte E-Mail-Adresse ein~",
    "emailPlaceholder": "Bitte geben Sie Ihre E-Mail-Adresse ein ",
    "keepLogin": "Angemeldet bleiben für 15 Tage ",
    "loading": "Anmeldung läuft... ",
    "loginToStore": "Bei Touka Store anmelden ",
    "noAccount": "Noch kein Konto? ",
    "password": "Passwort ",
    "passwordPlaceholder": "Bitte Passwort eingeben ",
    "submit": "Anmelden",
    "title": "Anmelden",
    "invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
  },
  "logout": {
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "dontRemind": "Nicht mehr erinnern",
    "messageLine1": "Nach dem Abmelden wird der Anmeldestatus auf allen Geräten, die in den letzten 30 Tagen verwendet wurden,",
    "messageLine2": "ungültig.",
    "title": "Hinweis"
  },
  "menu": {
    "contactSupport": "Kundenservice kontaktieren",
    "gameList": "Spielliste",
    "myOrders": "Meine Bestellungen"
  },
  "paymentSuccess": {
    "account": "Konto:",
    "celebrationTitle": "Kauf erfolgreich",
    "confirm": "Bestätigen",
    "getPaymentInfoFailed": "Fehler beim Abrufen der Zahlungsinformationen",
    "loading": "Wird geladen...",
    "orderDate": "Bestelldatum:",
    "orderId": "Bestellnummer:",
    "paymentMethod": "Zahlungsmethode:",
    "paypal": "PayPal",
    "price": "Preis:",
    "purchaseContent": "Kaufinhalt:",
    "quantity": "Kaufsmenge:",
    "serverAndCharacter": "Server/Charakter:",
    "title": "Danke für Ihren Kauf",
    "total": "Gesamt:",
    "unionPay": "UnionPay",
    "amountPaid": "Gezahlter Betrag:",
    "closeModal": "Schließen"
  },
  "productModal": {
    "confirm": "Bestätigen",
    "purchaseDetails": "Kaufdetails",
    "quantity": "Menge:",
    "total": "Gesamt:",
    "unitPrice": "Stückpreis:"
  },
  "redeemCode": {
    "title": "Einlösecode",
    "close": "Schließen",
    "gameIdLabel": "Spiel-ID:",
    "gameIdPlaceholder": "Geben Sie Ihre Spiel-ID ein",
    "howToFindGameId": "So finden Sie Ihre Spiel-ID",
    "giftCodeLabel": "Geschenkcode",
    "giftCodePlaceholder": "Geben Sie Ihren Geschenkcode ein",
    "captchaLabel": "Captcha:",
    "captchaPlaceholder": "Captcha eingeben",
    "refreshCaptcha": "Captcha aktualisieren",
    "submit": "Absenden",
    "submitting": "Wird gesendet...",
    "rule": "Jeder Geschenkcode kann pro Konto nur einmal eingelöst werden.",
    "success": {
      "title": "Erfolgreich eingelöst",
      "description": "Bitte holen Sie Ihre Belohnung im In-Game-Postfach ab!",
      "confirm": "OK"
    },
    "guide": {
      "stepOne": "1. Zur Einstellungsseite gehen",
      "stepTwo": "2. Spiel-ID kopieren"
    },
    "messages": {
      "enterGiftCode": "Bitte geben Sie zuerst einen Geschenkcode ein",
      "requiredFields": "Bitte füllen Sie alle Einlöseinformationen aus",
      "captchaLoadFailed": "Captcha konnte nicht geladen werden. Tippen Sie zum Wiederholen.",
      "success": "Erfolgreich eingelöst. Die Belohnungen wurden an Ihr In-Game-Postfach gesendet.",
      "redeemFailed": "Einlösen fehlgeschlagen. Bitte versuchen Sie es später erneut."
    },
    "resultMessages": {
      "0": "Einlösung erfolgreich! Die Belohnungen wurden an Ihr In-Game-Postfach gesendet. Bitte prüfen Sie es bald.",
      "1": "Die Benutzer-ID ist falsch. Bitte prüfen und erneut versuchen.",
      "2": "Der Einlösecode ist falsch. Bitte prüfen und erneut versuchen.",
      "3": "Der Einlösecode wurde bereits verwendet.",
      "4": "Der Einlösecode ist abgelaufen.",
      "5": "Der Einlösecode ist falsch. Bitte prüfen und erneut versuchen.",
      "6": "Der Einlösecode wurde vollständig eingelöst.",
      "7": "Der Server ist ausgelastet. Bitte versuchen Sie es später erneut.",
      "8": "Anfragefehler. Bitte versuchen Sie es später erneut.",
      "9": "Die Einlöseinformationen sind ungültig. Bitte gehen Sie zurück und versuchen Sie es erneut.",
      "10": "Der Spielserver des Charakters wurde nicht gefunden. Bitte prüfen Sie die Charakterinformationen und versuchen Sie es erneut. Der aktuelle Server ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
      "11": "Der aktuelle Server ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
      "12": "Abholung zeitüberschreitung. Bitte versuchen Sie es später erneut.",
      "13": "Abholung fehlgeschlagen. Bitte versuchen Sie es später erneut."
    }
  },
  "products": {
    "giftPacks": "Paket",
    "diamond": "Diamant",
    "products": "Artikel",
    "vouchers": "Super-Diamanten",
    "toukaCoin": "Super-Diamanten",
    "toukaCoinBonusTip": "Erhalte 10 % extra im TOUKA Store!",
    "superValue": "Top-Angebot",
    "limitShort": "Limit",
    "remainingShort": "Restzeit",
    "giftPackLimitType": {
      "lifetime": "Lebenslang",
      "weekly": "Wöchentlich",
      "monthly": "Monatlich"
    },
    "howToUseVouchers": "Wie verwendet man Super-Diamanten?",
    "voucherGuide": {
      "title": "Wie verwendet man Super-Diamanten?",
      "step1": "1. Bitte prüfen Sie Ihr In-Game-Postfach, um die gekauften Super-Diamanten zu erhalten.",
      "step2": "2. Oben im Tab des In-Game-Shops können Sie Ihr Super-Diamanten-Guthaben einsehen. Sobald Sie genügend Super-Diamanten für den Kauf eines Geschenkpakets haben, werden Super-Diamanten beim Kauf vorrangig verwendet.",
      "backToProducts": "Zur Produktliste zurückkehren"
    },
    "luxuryVouchers": "Super-Diamanten"
  },
  "purchaseConfirm": {
    "card": "Kreditkarte/EC-Karte",
    "confirm": "Bestätigen",
    "dontAskAgain": "In den nächsten 30 Tagen nicht mehr fragen",
    "gameServer": "Spielserver",
    "paymentMethods": "Unterstützte Zahlungsmethoden",
    "paypal": "PayPal",
    "title": "Möchten Sie diesen Kauf wirklich mit diesem Konto tätigen?",
    "unionPay": "UnionPay-Karte"
  },
  "serverSelect": {
    "characterLabel": "Charaktername",
    "characterPlaceholder": "Bitte wählen Sie einen Charakter",
    "confirm": "Bestätigen",
    "noResults": "Keine Ergebnisse",
    "serverPlaceholder": "Bitte geben Sie den Servernamen zur Suche ein",
    "title": "Spielserver auswählen"
  },
  "orientation": {
    "bestExperience": "Bitte wechseln Sie für das beste Erlebnis ins Hochformat"
  },
  "support": {
    "cancel": "Abbrechen",
    "copied": "Kopiert",
    "copy": "Mit einem Klick kopieren",
    "description": "Bitte senden Sie Ihre detaillierten Informationen an die offizielle Support-E-Mail-Adresse.",
    "title": "Kundensupport"
  },
  "verification": {
    "back": "Zurück",
    "enterCode": "Bitte geben Sie den Verifizierungscode ein, um fortzufahren",
    "incorrectCode": "Der Verifizierungscode ist falsch",
    "invalidCode": "Bitte geben Sie den 6-stelligen Verifizierungscode ein",
    "noCode": "Keinen Verifizierungscode erhalten?",
    "sentTo": "Der Verifizierungscode wurde gesendet an",
    "submit": "Absenden",
    "submitting": "Wird gesendet..."
  }
} as const;
